import Vue from 'vue';
import VARIANTS_OF_KEY, { keyPressed } from "@/utils/enum/VARIANTS_OF_KEY";
import searchService from "@/modules/search/services/search-services";
import router from "@/router";
import store from "@/store"
import GLOBAL_EVENT_LISTENERS from "@/utils/enum/GLOBAL_EVENT_LISTENERS";

const DEFAULT_ESC_HANDLER = () => {
    return store.dispatch('routingHistory/redirectToLastHistoryObject');
}

const DEFAULT_CTRL_SHIFT_F_HANDLER = () => {
    return searchService.routeToGlobalSearch();
}

const DEFAULT_CTRL_SHIFT_Q_HANDLER = () => {
    return router.push('/openWindows').catch(() => {});
}

export default {
    namespaced: true,
    state: {
        keyUpHandlers: {
            [GLOBAL_EVENT_LISTENERS.ESC]: DEFAULT_ESC_HANDLER,
            [GLOBAL_EVENT_LISTENERS.CTRL_SHIFT_F]: DEFAULT_CTRL_SHIFT_F_HANDLER,
            [GLOBAL_EVENT_LISTENERS.CTRL_SHIFT_Q]: DEFAULT_CTRL_SHIFT_Q_HANDLER,
            [GLOBAL_EVENT_LISTENERS.CTRL_SPACE]: () => {}
        }
    },
    mutations: {
        setKeyUpHandlerFor(state, { key, handler }) {
            Vue.set(state.keyUpHandlers, key, handler);
        },
        setKeyUpHandlersToDefault(state) {
            const defaultHandlers = {
                [GLOBAL_EVENT_LISTENERS.ESC]: DEFAULT_ESC_HANDLER,
                [GLOBAL_EVENT_LISTENERS.CTRL_SHIFT_F]: DEFAULT_CTRL_SHIFT_F_HANDLER,
                [GLOBAL_EVENT_LISTENERS.CTRL_SHIFT_Q]: DEFAULT_CTRL_SHIFT_Q_HANDLER,
                [GLOBAL_EVENT_LISTENERS.CTRL_SPACE]: () => {}
            }

            Vue.set(state, 'keyUpHandlers', defaultHandlers);
        },
    },
    actions: {
        async keyUpHandler({ state }, event) {
            if (keyPressed(VARIANTS_OF_KEY.ESC, event)) { return state.keyUpHandlers[GLOBAL_EVENT_LISTENERS.ESC](); }

            const isCrtlShiftF = event.ctrlKey && event.shiftKey && keyPressed(VARIANTS_OF_KEY.F, event);
            if (isCrtlShiftF === true) { return state.keyUpHandlers[GLOBAL_EVENT_LISTENERS.CTRL_SHIFT_F](); }

            const isCrtlShiftQ = event.ctrlKey && event.shiftKey && keyPressed(VARIANTS_OF_KEY.Q, event);
            if (isCrtlShiftQ) { return state.keyUpHandlers[GLOBAL_EVENT_LISTENERS.CTRL_SHIFT_Q](); }

            const isCtrlSpace = event.ctrlKey && keyPressed(VARIANTS_OF_KEY.SPACE, event);
            if(isCtrlSpace) { return state.keyUpHandlers[GLOBAL_EVENT_LISTENERS.CTRL_SPACE](); }
        },
        setKeyUpHandlerFor({ state, commit }, { key, handler }) {
            const currentKeyUpHandler = state.keyUpHandlers[key];
            commit('setKeyUpHandlerFor', { key, handler });
            return currentKeyUpHandler;
        },
        setKeyUpHandlersToDefault({ commit }) {
            commit('setKeyUpHandlersToDefault');
        },
    }
}
